import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Tokenomics from './components/Tokenomics';
import Footer from './components/Footer';
import Music from './components/Music';

function App() {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <Hero />
      <Tokenomics />
      <Footer />
      <Music />
    </div>
  );
}

export default App;
